import React, { ReactNode, CSSProperties } from 'react';
import { colors, spacing, typography } from '../../../tokens';

export interface SectionTitleProps {
  children: ReactNode;
  style?: CSSProperties;
  marginBottom?: keyof typeof spacing;
}

export const SectionTitle: React.FC<SectionTitleProps> = ({
  children,
  style = {},
  marginBottom = 'lg',
}) => {
  return (
    <h2
      style={{
        fontSize: typography.fontSize['4xl'],
        fontWeight: typography.fontWeight.extrabold,
        fontFamily: typography.fontFamily.heading,
        color: colors.text.primary.default,
        letterSpacing: typography.letterSpacing.normal,
        margin: `0 0 ${spacing[marginBottom]} 0`,
        ...style,
      }}
    >
      {children}
    </h2>
  );
};
